import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PI } from '../../constants-types';
import {
    AvatarBulkServer,
    AvatarsAvailable,
    AvatarServer,
    AvatarUpdate
} from '../../core-data-model';
import { UserProfileSettingsService } from '../../system-services';
import { ApiService } from '../../system-services/Api.service';

@Injectable({
    providedIn: 'root'
})
export class AvatarApi {
    private accountManagementApiPrefix = '/api/v5/user/identity';
    private readonly companyGuid: string = null;

    constructor(
        private http: HttpClient,
        private api: ApiService,
        private userProfile: UserProfileSettingsService
    ) {
        this.companyGuid = this.userProfile.currentCompany;
    }

    getBulkAvatars(): Observable<AvatarBulkServer> {
        return this.http.get<AvatarBulkServer>(
            this.avatarApiEndpoint(`company/${this.companyGuid}`)
        );
    }

    getAvailableAvatars(email: string): Observable<AvatarsAvailable> {
        return this.http.get<AvatarsAvailable>(
            this.avatarApiEndpoint(`availableavatars/${email.toLowerCase()}`)
        );
    }

    getAvatar(email: string): Observable<AvatarServer> {
        return this.http.get<AvatarServer>(
            this.avatarApiEndpoint(`avatar/${email.toLowerCase()}`)
        );
    }

    updateAvatar(email: string, url: string): Observable<AvatarUpdate> {
        return this.http.patch<{
            email: string;
            selectedAvatarUrl: string;
            companyGuid: string;
            isAvatarEnabled: boolean;
        }>(this.avatarApiEndpoint('avatar'), {
            email: email.toLowerCase(),
            selectedAvatarUrl: url,
            companyGuid: this.companyGuid,
            isAvatarEnabled: true
        });
    }

    private avatarApiEndpoint(endpoint: string): string {
        let baseApi = PI?.appSettings?.accountManagementApiUrl ?? '';
        baseApi = baseApi.replace(/\/$/, '').concat('/');
        endpoint = endpoint.replace(/(^\/{0,2})|(\/{0,2}$)/g, '');

        return baseApi.concat(`${this.accountManagementApiPrefix}/${endpoint}`);
    }
}
